import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { AccessibilityRole } from 'react-native'

import styled from 'styled-components/native'

import { AccessibilityRolesNative, IS_WEB } from '../../../constants'
import { tID } from '../../../utils/utils'
import { BodyText, Size as BodyTextSize } from '../../bodyText/BodyText'
import { RestingCatIllustration } from '../../illustrations/RestingCatIllustration'
import { Subhead, Size as SubheadSize } from '../../subhead/Subhead'

const Container = styled.View({
  width: '100%',
})

const Content = styled.View(({ theme }) => ({
  maxWidth: '256px',
  alignItems: 'center',
  margin: '0 auto',
  paddingVertical: theme.spacing['24px'],
}))

const SubheadStyled = styled(Subhead)(({ theme }) => ({
  marginVertical: theme.spacing['4px'],
}))

export const SearchNoResults = () => {
  const { formatMessage } = useIntl()
  return (
    <Container
      testID={tID('typeAhead-searchNoResults')}
      accessibilityRole={IS_WEB ? ('listbox' as AccessibilityRole) : AccessibilityRolesNative.MENU}
      accessibilityLabel={formatMessage({
        defaultMessage: 'No results found',
        description: 'Accessibility label for when there are no results found in a dropdown menu',
      })}
    >
      <Content>
        <RestingCatIllustration />
        <SubheadStyled
          text={<FormattedMessage defaultMessage='No results found' description='Title for no search results found' />}
          size={SubheadSize.XSMALL}
          textAlign='center'
        />
        <BodyText
          text={
            <FormattedMessage
              defaultMessage='Try searching again with only a single word or less filters'
              description='Body text for no search results found'
            />
          }
          size={BodyTextSize.SMALL}
          textAlign='center'
        />
      </Content>
    </Container>
  )
}
